import pushRoute from '@utils/pushRoute';
import { getVideoUrlInternal, getItemRedirectURL } from '@models/Item';
import { programmeTypes } from '@constants/index';

const getVideoUrl = (defaultURL, classDetails, isExternal) => {
  const videoUrl = getVideoUrlInternal(classDetails, isExternal);

  if (!videoUrl) {
    return defaultURL;
  }

  if (
    defaultURL?.split('/v')[1]?.split('/')[0] !==
    videoUrl?.split('/v')[1]?.split('/')[0]
  ) {
    return videoUrl;
  }

  return defaultURL;
};

export const getClassProcessedData = (classDetails) => {
  const {
    uid,
    goalUid,
    name,
    slidesPdf = {},
    programme = {},
    programmeType = 1,
    author = {},
    classType = 1,
    recordedType,
    liveAt,
    rank,
    state,
    secondsBeforeLive = 0,
    duration,
    videoDuration,
    lessonDuration,
    finishedAt,
    startedAt,
    isSaved = false,
    videoUrl,
    liveClassUrl,
    preview,
    llhls
  } = classDetails;

  const updateDuration = videoDuration || lessonDuration || duration || 0;

  const formattedData = {
    preview,
    name,
    uid,
    liveAt,
    live_at: liveAt,
    rank,
    state,
    author: {
      uid: author.uid,
      username: author.username,
      first_name: author.firstName,
      last_name: author.lastName,
      avatar: author.thumbnail || author.avatar || author.avatarV1
    },
    startedAt,
    finishedAt,
    isSaved,
    secondsBeforeLive,
    programmeType,
    classType,
    recordedType,
    videoUrl,
    liveClassUrl,
    lessonDuration: updateDuration,
    videoDuration: updateDuration,
    goalUid: goalUid || programme.goal?.uid,
    isEnrolled: programme.isEnrolled || false,
    programme: {
      name: programme.name || '',
      isSpecial: programme.isSpecial || false
    },
    slides: {
      withAnnotations:
        slidesPdf?.withAnnotations || slidesPdf?.withAnnotation || null,
      withoutAnnotations:
        slidesPdf?.withoutAnnotations || slidesPdf?.noAnnotation || null
    },
    course: {
      title: programme.name
    },
    llhls
  };

  return formattedData;
};

export const getStreamURL = (
  classDetails,
  unLiveURL,
  isExternal,
  clxVersion
) => {
  let streamUrl = getVideoUrl(unLiveURL, classDetails, isExternal);

  if (streamUrl) {
    const firstPart = streamUrl.split('?')[0];
    streamUrl = firstPart;
  }

  if (clxVersion) {
    streamUrl = streamUrl.replace(/\/v+\d*/, `/v${clxVersion}`);
  }

  return streamUrl;
};

export const getNextLessonURL = (data) => {
  const { as } = getItemRedirectURL(data, true) || {};

  return as;
};

export const getLessonProgrammeType = (programmeType) => {
  if (programmeType === programmeTypes.COURSE) {
    return 'Course';
  }
  if (programmeType === programmeTypes.TESTSERIES) {
    return 'Test Series';
  }
  return 'NA';
};

export const getKeyFromState = (state = {}) => {
  return state.key || state.option?.key;
};

export const subscriptionTypes = {
  1: 'PLUS',
  2: 'TRIAL',
  5: 'ICONIC',
  6: 'COMBO'
};

export const navigateToHome = () => {
  pushRoute('/', '/');
};

export const browserBack = () => {
  window.history.back();
};

export const isClassroom = (route) => {
  return route.startsWith('/classroom');
};
